export default __webpack_public_path__ + "media/assets/img/img_icon_standard_txt-28ba4b60f98976ffe7647380c2b8ed0e.svg";